var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-row my-5 flex items-center justify-center"},[_c('div',{staticClass:"vx-col xl:w-1/2 lg:w-2/3 w-full my-5"},[_c('responsive-iframe',{attrs:{"src":_vm.video,"posterimg":_vm.image}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }